// External Dependencies:
import React from 'react'

// Internal Dependencies:
import ImageSliderModal from 'components/slider/slider-modal'
import getYouTubeId from 'utilities/video'

class Slider extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			slidesCount: props.images.length,
			activeSlide: 1,
			autoChange: true,
			showImageModal: false,
			imageModalSrc: ''
		}
	}

	componentDidMount() {
		this.interval = setInterval( this.timer, 5000 )
	}

	componentWillUnmount() {
		clearInterval( this.interval )
	}

	componentDidUpdate( prevProps, prevState ) {
		// When the props change, reset the slider:
		if ( this.props.images.length != prevProps.images.length ) {
			this.setState({
				slidesCount: this.props.images.length,
				activeSlide: 1,
				autoChange: true
			})
		}
	}

	handleClick = ( e ) => {
		const url = e.currentTarget.getAttribute( 'src' )

		this.setState({
			showImageModal: true,
			imageModalSrc: url
		})
	}

	timer = () => {
		const { autoChange, slidesCount, activeSlide } = this.state

		if ( autoChange ) {
			this.setState({
				activeSlide: activeSlide == slidesCount ? 1 : activeSlide + 1
			})
		}
	}

	selectPrev = () => {
		const { slidesCount, activeSlide } = this.state

		this.setState({
			autoChange: false,
			activeSlide: activeSlide == 1 ? slidesCount : activeSlide - 1
		})
	}

	selectNext = () => {
		const { slidesCount, activeSlide } = this.state

		this.setState({
			autoChange: false,
			activeSlide: activeSlide == slidesCount ? 1 : activeSlide + 1
		})
	}

	handleCancel = () => {
		this.setState({
			showImageModal: false
		})
	}

	render() {
		const { images } = this.props
		const { activeSlide, showImageModal } = this.state
		let imageSliderMarkup = []

		if ( images && images.length ) {
			imageSliderMarkup = images.map( ( url, i ) => {
				let className = activeSlide == ( i + 1 ) ? 'is-active' : ''

				if ( url.indexOf( 'youtu' ) != -1 ) {
					className += ' slider-video'
					let videoId = getYouTubeId( url )
					let iframeSrc = `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&amp;showinfo=0`

					return (
						<div
							key={ url }
							className={ className }
							src={ url }
							onClick={ this.handleClick }
						>
							<iframe src={ iframeSrc } frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen />
						</div>
					)
				} else {
					return (
						<img
							key={ url }
							className={ className }
							src={ url }
							alt=""
							onClick={ this.handleClick }
						/>
					)
				}
			})

			return (
				<div className="image-slider">
					{ imageSliderMarkup }

					<nav>
						<i className="-back icon-chevron-down" onClick={ this.selectPrev }></i>
						<i className="-forward icon-chevron-down" onClick={ this.selectNext }></i>
					</nav>

					{ showImageModal &&
						<ImageSliderModal images={ images } isOpen={ showImageModal } activeSlide={ activeSlide } cancel={ this.handleCancel } />
					}
				</div>
			)
		}

		return null
	}
}

export default Slider



// WEBPACK FOOTER //
// ./components/slider/slider.jsx